import { useState } from "react";
import { Check, MessageCircle, Send, X } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../../context/LanguageContext";
import { api, errorMessage, TELEGRAM, whatsappLink } from "../../lib/api";

const FIELDS = (t) => [
  ["full_name", t.reg.name, "text", "Dr. Ahmed Mohammed", true, "full"],
  ["specialty", t.reg.specialty, "text", "e.g. Cardiology, Internal Medicine...", true, "full"],
  ["email", t.reg.email, "email", "email@example.com", true, "full"],
];

export const RegistrationForm = ({ opp, onDone, endpoint = "/registrations", headers, compact = false }) => {
  const { t } = useLang();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    const payload = Object.fromEntries(new FormData(e.currentTarget).entries());
    try {
      const r = await api.post(endpoint, { ...payload, opportunity_id: opp.id }, { headers });
      setResult({ ...payload, ...r.data }); toast.success(t.reg.successTitle); onDone?.(r.data);
    } catch (err) { toast.error(errorMessage(err, t.reg.error)); }
    finally { setLoading(false); }
  };

  if (result) {
    const msg = `السلام عليكم، سجّلت في فرصة بحثية وأرغب باعتماد تسجيلي:\n• الفرصة: ${opp.title_en}\n• التخصص: ${opp.specialty_ar}\n• الاسم: ${result.full_name}\n• التخصص الدقيق: ${result.specialty}\n• رقم الواتساب: ${result.phone}\n• البريد: ${result.email}`;
    return (
      <div className="success-box" data-testid="registration-success">
        <span className="ring"><Check size={32} /></span>
        <h3>{t.reg.successTitle}</h3><p className="muted" style={{ marginTop: 8, lineHeight: 1.8 }}>{t.reg.successSub}</p>
        {!compact && <a className="btn btn-whatsapp btn-block" style={{ marginTop: 18 }} href={whatsappLink(msg)} target="_blank" rel="noreferrer" data-testid="success-whatsapp"><MessageCircle size={18} />{t.reg.waButton}</a>}
      </div>
    );
  }

  return (
    <form className="form" onSubmit={submit} data-testid="registration-form">
      {FIELDS(t).map(([name, label, type, ph, req, cls]) => <label className={cls} key={name}><span>{label}{req && <span className="req"> *</span>}</span><input name={name} type={type} placeholder={ph} required={req} data-testid={`reg-${name.replace("_", "-")}-input`} /></label>)}
      <label className="full"><span>{t.reg.phone} <span className="req">* {t.reg.required}</span></span><input name="phone" type="tel" placeholder="+966 5XXXXXXXX" required pattern="^\+?[0-9\s\-]{9,16}$" data-testid="reg-phone-input" /><span className="hint">{t.reg.phoneHint}</span></label>
      <label className="full">{t.reg.institution}<input name="institution" placeholder="e.g. King Faisal Specialist Hospital..." data-testid="reg-institution-input" /></label>
      <label>{t.reg.country}<input name="country" placeholder="e.g. Saudi Arabia" data-testid="reg-country-input" /></label>
      <label>{t.reg.city}<input name="city" placeholder="e.g. Riyadh" data-testid="reg-city-input" /></label>
      <label className="full">{t.reg.orcid}<input name="orcid" placeholder="0000-0001-2345-6789" data-testid="reg-orcid-input" /></label>
      <button className="btn btn-primary" type="submit" disabled={loading} data-testid="reg-submit-button">{loading ? <span className="loader" /> : t.reg.submit}</button>
    </form>
  );
};

export const RegistrationModal = ({ opp, onClose }) => {
  const { t } = useLang();
  const isFull = opp.status !== "open" || opp.remaining_seats <= 0;
  return (
    <div className="modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal" data-testid="registration-modal">
        <button className="modal-close" onClick={onClose} data-testid="registration-modal-close"><X size={18} /></button>
        {isFull ? (
          <div className="success-box" data-testid="registration-full"><h3>{t.reg.fullTitle}</h3><p className="muted" style={{ marginTop: 8 }}>{t.reg.fullSub}</p>
            <a className="btn btn-outline" style={{ marginTop: 16 }} href={TELEGRAM} target="_blank" rel="noreferrer"><Send size={16} />Telegram</a></div>
        ) : (<>
          <h2>{t.reg.title}<span className="en">{opp.title_en}</span></h2>
          <p className="muted" style={{ fontSize: 14 }}>{t.reg.sub}</p>
          <RegistrationForm opp={opp} />
        </>)}
      </div>
    </div>
  );
};
